export enum TrackingSettingsTheme {
    Default = 'DEFAULT',
    DataGrid = 'DATAGRID',
}

export enum TrackingItemStatus {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED',
}

export enum DataSourceNames {
    Xero = 'XERO',
    Quickbooks = 'QUICKBOOKS',
    QuickBooksDesktop = 'QUICKBOOKSDESKTOP',
    MyobAccountRight = 'MYOBACCOUNTRIGHT',
    MyobAccountRightDesktop = 'MYOBACCOUNTRIGHTDESKTOP',
    Sage50Desktop = 'SAGE50DESKTOP',
    SageIntacct = 'SAGEINTACCT',
}
